import * as React from 'react';

import './index.scss';

interface IProps {
    content: string;
}

export const LongScreen: React.FC<IProps> = ({
    content,
}) => {
    return (
        <div className="longScreen">
            <div className="longScreen__container">
                <div className="longScreen__scrollable">
                    <img src={content} alt="" />
                </div>
            </div>
        </div>
    );
};
